import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* ヒーローセクション */}
      <div className="flex flex-col items-center justify-center min-h-[70vh] bg-gradient-to-b from-blue-50 to-gray-100 p-4">
        <h1 className="text-5xl font-bold mb-6 text-blue-900">こんたくん</h1>
        <p className="text-2xl mb-8 text-center text-gray-700 max-w-2xl">
          AIが問い合わせを自動仕分け。効率的な顧客対応を実現
        </p>
        <div className="space-x-4">
          <Button size="lg" className="bg-blue-600 hover:bg-blue-700" asChild>
            <Link to="/app">無料で始める</Link>
          </Button>
        </div>
      </div>

      {/* 機能セクション */}
      <div className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">主な機能</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="p-6">
              <h3 className="text-xl font-semibold mb-4">AI重要度分析</h3>
              <p className="text-gray-600">
                AIが問い合わせ内容を分析し、0-100点の重要度スコアを付与。
                優先して対応すべき案件を瞬時に特定できます。
              </p>
            </Card>
            <Card className="p-6">
              <h3 className="text-xl font-semibold mb-4">カスタマイズ設定</h3>
              <p className="text-gray-600">
                重要度の閾値やAIプロンプトをカスタマイズ可能。
                あなたのビジネスに最適な分析基準を設定できます。
              </p>
            </Card>
            <Card className="p-6">
              <h3 className="text-xl font-semibold mb-4">簡単導入</h3>
              <p className="text-gray-600">
                既存のお問い合わせフォームにスクリプトを追加するだけで利用開始。
                分析結果はメールで自動通知されます。
              </p>
            </Card>
          </div>
        </div>
      </div>

      {/* 料金プラン */}
      <div className="py-20 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">料金プラン</h2>
          <div className="max-w-2xl mx-auto">
            <Card className="p-8">
              <h3 className="text-2xl font-bold mb-4">ベータ版特別プラン</h3>
              <div className="text-4xl font-bold mb-6">¥0<span className="text-lg text-gray-600">/月</span></div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <span className="mr-2">✓</span>
                  全機能利用可能
                </li>
                <li className="flex items-center">
                  <span className="mr-2">✓</span>
                  無制限の問い合わせ処理
                </li>
                <li className="flex items-center">
                  <span className="mr-2">✓</span>
                  テクニカルサポート付き
                </li>
              </ul>
              <Button className="w-full bg-blue-600 hover:bg-blue-700" asChild>
                <Link to="/app">無料で始める</Link>
              </Button>
              <p className="text-sm text-gray-500 mt-4 text-center">
                ※ベータ版期間中は全機能を無料でご利用いただけます
              </p>
            </Card>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">よくある質問</h2>
          <div className="space-y-6">
            <Card className="p-6">
              <h3 className="text-xl font-semibold mb-2">ベータ版の利用条件は？</h3>
              <p className="text-gray-600">
                ベータ版は3ヶ月間のモニター契約となります。期間中は全機能を無償でご利用いただけます。
                サービス改善のため、月1回以上のフィードバック提供をお願いしています。
              </p>
            </Card>
            <Card className="p-6">
              <h3 className="text-xl font-semibold mb-2">契約期間の縛りはありますか？</h3>
              <p className="text-gray-600">
                いいえ、月額プランは毎月の自動更新で、いつでもキャンセル可能です。
                長期契約の縛りはございません。
              </p>
            </Card>
            <Card className="p-6">
              <h3 className="text-xl font-semibold mb-2">導入にあたってのサポートはありますか？</h3>
              <p className="text-gray-600">
                はい、初期設定のサポートを含め、メールやチャットでのテクニカルサポートをご提供しています。
                プロプランではより手厚いサポートをご利用いただけます。
              </p>
            </Card>
          </div>
        </div>
      </div>

      {/* フッター */}
      <div className="bg-gray-900 text-white py-12 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-8">今すぐ始めましょう</h2>
          <p className="text-xl mb-8 text-gray-300">
            無料プランで「こんたくん」の機能を体験できます
          </p>
          <Button size="lg" className="bg-blue-600 hover:bg-blue-700" asChild>
            <Link to="/app">無料で始める</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
